import { useQuery } from 'react-query';
import { METADATA } from '../../constants/queryKeys';
import useAxiosInstance from '../useAxiosInstance';
import { EntityMetadata as Metadata } from '../../interfaces/EntityMetadata';
import { getMetadataByEntityName } from '../../services/ConfigService/ConfigService';

export default function useGetMetadataByEntityNameQuery(entityName: string) {
  const { axios } = useAxiosInstance();

  return useQuery<Metadata | undefined>([METADATA, entityName], async () =>
    getMetadataByEntityName(axios, entityName)
  );
}
